import { RG_TECH_CLASS } from '../types/rg-tech-class.js';
import { RG_TECH_TYPE } from '../types/rg-tech-type.js';

/**
 * @deprecated use `SpaceInstance.spaceClass` instead
 * Store which RG_TECH_TYPE belong to which RG_TECH_CLASS
 */
const TechSpaceClassifications = {
    [RG_TECH_TYPE.TankRoomCWSSprinkler]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.TankRoomRWH]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.TankRoomGreyWater]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.ElectricalIntake]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.ElectricalBackupPower]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.ElectricalBMSComms]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.BuildingThermalEnergy]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.CentralThermalEnergy]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.CycleStore]: RG_TECH_CLASS.Amenity,
    [RG_TECH_TYPE.BinStore]: RG_TECH_CLASS.Amenity,
    [RG_TECH_TYPE.ElectricalMainsIntake]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.ElectricalPlantConsBackupPowerComms]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.MechanicalPlantConsThermalStore]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.MechanicalPlantConsThermalStoreTank]: RG_TECH_CLASS.Service,
    [RG_TECH_TYPE.ElectricalPlantConsIntakeComms]: RG_TECH_CLASS.Service
};

export { TechSpaceClassifications };
//# sourceMappingURL=space-classes.js.map
